export default __webpack_public_path__ + "img/earn-points-icon-9f82ae8cf2a9d734c9ab49cccaacae7c.png";